import { render } from "./ContactPage.vue?vue&type=template&id=56f54228&scoped=true"
import script from "./ContactPage.vue?vue&type=script&lang=js"
export * from "./ContactPage.vue?vue&type=script&lang=js"

import "./ContactPage.vue?vue&type=style&index=0&id=56f54228&scoped=true&lang=css"
import "./ContactPage.vue?vue&type=style&index=1&id=56f54228&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f54228"]])

export default __exports__